<template>
  <div class="lotto-ball " :class="classStr">
    {{ number ? number : ' ' }}
  </div>
</template>

<script>
const colors = [
  { k: 1, color: 'green' },
  { k: 2, color: 'red' },
  { k: 3, color: 'orange' },
  { k: 4, color: 'yellow' },
  { k: 5, color: 'brown' },
  { k: 6, color: 'purple' },
  { k: 0, color: 'blue'  }
]
  export default {
    name: "LottoBallNumber",
    props:{
      number: {
        required: true
      },
      isColored: {
        default: false
      },
      isSmaller: {
        type: Boolean
      }
    },
    computed:{
      colorClass() {
        if (!this.isColored) {
          return ''
        }
        return colors.find(el => el.k === (this.number % 7))?.color;
      },

      classStr() {
        return `${this.isSmaller ? 'small' : ''} ${this.colorClass}`
      }
    }
  }
</script>

<style scoped lang="scss">
  .lotto-ball {
    font-weight: 700;
    color: black;
    display: inline-flex;
    // width: 3rem;
    // height: 3rem;

    font-size: 1rem;
    
    width: 3.125rem;
    height: 3.125rem;

    width: 2.5rem;
    height: 2.5rem;

    align-items: center;
    justify-content: center;
    border-radius: 50%;
    // border: 8px solid var(--geoff-accent);
    // background: radial-gradient(circle, 
    //   white 0%,
    //   white 40%,
    //   var(--geoff-accent) 40%,
    //   var(--geoff-accent) 40%);
    // box-shadow: -3px -4px 6px inset black;

    
    background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      var(--geoff-accent) 45%,
      var(--geoff-accent) 100%);
    box-shadow: -3px -4px 9px -3px inset black;

    // small balls for smaller screens
    @media only screen and (max-width: 368px) {
      width: 2rem;
      height: 2rem;
    }

    &.small {
      width: 2rem;
      height: 2rem;
    }

    &.green {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      green 45%,
      green 100%)
    }
    &.red {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      red 45%,
      red 100%)
    }
    &.orange {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      orange 45%,
      orange 100%)
    }
    &.yellow {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      yellow 45%,
      yellow 100%)
    }
    &.brown {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      #6c3c0c 45%,
      #6c3c0c 100%)
    }
    &.purple {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      purple 45%,
      purple 100%)
    }
    &.blue {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      blue 45%,
      blue 100%)
    }

   

    &.white {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      white 45%,
      white 100%)
    }

    &.grey {
      background: radial-gradient(
      circle, 
      white 0%,
      white 45%,
      #cfcfcf 45%,
      #cfcfcf 100%)
    }

    &.faded {
      opacity: 0.2;
    }
    
  }

</style>